import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const eventsPlugin = createPlugin({
  id: 'events',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindEventsRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(eventsPlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...eventsPlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceEventsPage = eventsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceEventsPage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-events", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
